// src/services/aiService.js
import api from './api';

const aiService = {
  // Ask AI question
  askAI: async (question, context = '') => {
    try {
      const response = await api.post('/v1/ai/ask', { question, context });
      return response.data;
    } catch (error) {
      console.error('Error asking AI:', error);
      throw error;
    }
  },

  // Summarize text
  summarize: async (text, length = 'medium') => {
    try {
      const response = await api.post('/v1/ai/summarize', { text, length });
      return response.data;
    } catch (error) {
      console.error('Error summarizing text:', error);
      throw error;
    }
  },

  // Generate questions from text
  generateQuestions: async (text, count = 5, type = 'mixed') => {
    try {
      const response = await api.post('/v1/ai/questions', { text, count, type });
      return response.data;
    } catch (error) {
      console.error('Error generating questions:', error);
      throw error;
    }
  },

  // Get AI usage stats
  getUsageStats: async () => {
    try {
      const response = await api.get('/v1/ai/usage');
      return response.data;
    } catch (error) {
      console.error('Error getting AI usage stats:', error);
      throw error;
    }
  }
};

export default aiService;